import React, { forwardRef } from 'react';
import { Typography } from 'Tokens';
import { VStack, AccordionButton, AccordionItem, AccordionPanel, HStack } from '@chakra-ui/react';
import mixpanel from 'mixpanel-browser';
import { TRACKING_EVENTS } from '../../utils/mixpanel';
import { Article } from './KnowledgeBase.hooks';
import { ArticleBox } from 'containers/Article';
import { ChevronDownIcon, ChevronRightIcon } from 'Tokens/Icons/Direction';


export const ArticleResultItem = forwardRef<HTMLDivElement, { article: Article }>(
  ({ article }, ref) => {
    const handleClick = () => {
      mixpanel.track(TRACKING_EVENTS.KNOWLEDGE_BASE.ARTICLE_CLICK, {
        articleId: article.id,
        title: article.title,
      });
    };


  return (
    <AccordionItem
      width="100%"
      borderWidth="1px"
      borderColor="border.decorative"
      outlineColor="border.decorative"
      borderRadius="12px"
      flex="1"
      ref={ref}
    >
      {({ isExpanded }) => (
        <>
          <AccordionButton onClick={handleClick}>
            <HStack justifyContent="flex-start" spacing="14px" minH="60px" alignItems="center">
              {isExpanded ? (
                <ChevronDownIcon color="inherit" />
              ) : (
                <ChevronRightIcon color="inherit" />
              )}
              <VStack alignItems="start" spacing={0}>
                <Typography variant="h3" textAlign="start">
                  {article.title}
                </Typography>
                <Typography variant="detail" textAlign="start">
                  {article.tags.map((tag) => tag.Tag.name).join(', ')}
                </Typography>
              </VStack>
            </HStack>
          </AccordionButton>
          <AccordionPanel pb={4}>
            <ArticleBox showTitle={false} preLoadedArticle={article} margin={2} />
          </AccordionPanel>
        </>
      )}
    </AccordionItem>
  );
});

ArticleResultItem.displayName = 'ArticleResultItem';